import { getDisplayCurrency } from '../currencyStore.js';

const MONEY_LOCALE = { MXN: 'es-MX', USD: 'en-US' };

/**
 * Formatea `n` en la moneda dada (por defecto, la moneda de display activa).
 * IMPORTANTE: `n` ya debe venir convertido a esa moneda — esta función solo
 * aplica el símbolo/locale, no convierte.
 */
export const fmtMoney = (n, currency = getDisplayCurrency()) =>
  isFinite(n)
    ? n.toLocaleString(MONEY_LOCALE[currency] || 'es-MX', {
        style: 'currency',
        currency: currency || 'MXN',
        maximumFractionDigits: 2,
      })
    : '—';

export const fmtInt = (n) => (n || 0).toLocaleString('es-MX');

export function parseAmount(s) {
  if (!s) return 0;
  const cleaned = String(s).replace(/[^\d.,-]/g, '').replace(/,/g, '');
  const n = parseFloat(cleaned);
  return isFinite(n) ? n : 0;
}

export function escapeHtml(s) {
  return String(s || '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[c]));
}

export function truncate(s, n) {
  s = String(s || '');
  return s.length > n ? s.slice(0, n - 1) + '…' : s;
}
